import { gql, useQuery } from "@apollo/client";

export const OrderAddressFragment = gql`
  fragment OrderAddressFragment on PublicareOrderAddress {
    _id
    code
    address {
      firstName
      lastName
      company
      addressLine
      addressLine2
      postalCode
      city
    }
  }
`;

export const ClientAddressesQuery = gql`
  query ClientAddresses($clientId: ID!) {
    client(clientId: $clientId) {
      _id
      lastOrderAddress {
        ...OrderAddressFragment
      }
      orderAddresses {
        ...OrderAddressFragment
      }
    }
  }
  ${OrderAddressFragment}
`;

const useClientAddresses = (clientId) => {
  const { data, error, loading } = useQuery(ClientAddressesQuery, {
    variables: {
      clientId,
    },
    skip: !clientId,
  });

  const addresses = data?.client?.orderAddresses || [];
  const lastOrderAddress = data?.client?.lastOrderAddress;

  return {
    addresses,
    lastOrderAddress,
    error,
    loading,
  };
};

export default useClientAddresses;
